import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

export default {
  name: 'nodesFiberChannel',
  namespaced: true,
  state: {
    fc: {},
    pending: false,
  },
  getters: {
    getFiberChannel: state => nodeId => state.fc[nodeId] || [],
    getPending: state => state.pending,
  },
  mutations: {
    SET_FC(state, payload) {
      state.fc = payload;
    },
    SET_PENDING(state, status) {
      state.pending = status;
    }
  },
  actions: {
    FETCH_FIBER_CHANNEL({ commit }) {
      commit('SET_PENDING', true);

      return getClusterId()
        .then(clusterId => this.$api.get(`/api/v2/${clusterId}/iscsi-alua/fc-ports/`))
        .then((response) => {
          commit('SET_FC', response.data.reduce((memo, item) => {
            memo[item.node_id] = item.ports; return memo;
          }, {}));
          return response;
        })
        .finally(() => {
          commit('SET_PENDING', false);
        });
    }
  }
};
